import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  container: {
    height: 64,
    minWidth: 260,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 8,
    paddingRight: 16,
    paddingLeft: 16,
    borderStyle: 'solid',
    borderWidth: 1,
    borderRadius: 16,
    borderColor: theme.palette.text.hint,
    backgroundColor: theme.palette.background.default,
  },
  title: {
    fontSize: 16,
    fontWeight: 700,
    textTransform: 'uppercase',
    marginLeft: 8,
  },
  button: {
    backgroundColor: theme.palette.background.default,
    borderRadius: 16,
    border: 'none',
    display: 'flex',
    alignItems: 'center',
    // padding: 8,
  },
  iconButton: {
    '& :hover': {
      cursor: 'pointer',
    },
  },
}));
